/**
 * Crew jobs on My Jobs (11/3, "go core"). When the office puts a second tech
 * on a job, the added tech's card already says "Lead: William". The lead's
 * card now says who is coming: "With: Mike". A crew job is for that one job;
 * nobody's other jobs change.
 */
export interface CrewBadgeJob {
    assigned_to?: string | null;
    crew?: Array<{ user_id: string; name: string | null }> | null;
}

/** "Mike" or "Mike, Joe" for the lead; null for anyone else or a one-tech job. */
export function withNamesFor(job: CrewBadgeJob, meId: string | null | undefined): string | null {
    if (!meId || job.assigned_to !== meId) return null;
    const names = (job.crew ?? [])
        .filter((c) => c.user_id && c.user_id !== meId)
        .map((c) => (c.name ?? "").trim().split(/\s+/)[0] || "a tech");
    return names.length ? names.join(", ") : null;
}
